import React from "react";
import Layout from "./components/Layout";

function App() {
  return (
    <div className="container">
        <h3>
          Custom horizontal Scroll
        </h3>
        <p>
          Let's <b>Scroll</b> 
          {` down. You can see the horizontal scroll will
          always float on the screen. Reference: `}
          <a href="https://github.com/anoopalex/custom-horizontal-scroll">
            GitHub
          </a>{" "}
          <a href="https://www.npmjs.com/package/custom-horizontal-scroll">
            npm
          </a>
        </p>
      <div className="vertical-scroll">
        <Layout />
        <Layout />
        <Layout />
        <Layout />
        <Layout />
        <Layout />
        <Layout />
        <Layout />
        <Layout />
        <Layout />
        <Layout />
        <Layout />
        <Layout />
      </div>
    </div>
  );
}

export default App;
